class MediaPlayer {

  type: 'audio' | 'video' | 'iframe';
  player: HTMLVideoElement | HTMLAudioElement | null;

  /**
   * @param {Element} element
   */
  constructor(element: Element) {
    // If the reduced motion is enable, disable autoplay of all videos
    if (this._isReducedMotion()) {
      // On Sitebuilder's videos
      element.querySelectorAll<HTMLVideoElement>('video').forEach(this._disableAutoplay);
      // On embedded videos
      element.querySelectorAll<HTMLIFrameElement>('section.media-component iframe')
        .forEach(iframe => this._disableAutoplayOnEmbeddedVideos(iframe));
    }

    const audioElement = element.querySelector('audio');
    const videoElement = element.querySelector('video');

    if (audioElement === null && videoElement === null) {
      this.type = 'iframe';
      return; // Assume iframe then
    }

    if (audioElement !== null && videoElement !== null) {
      throw new Error('Found both audio and video in media player element');
    }

    // Nothing to do here because we are using the native audio and video elements.
  }

  /**
   * Disable autoplay and on hosted videos
   * @param videoElement The video element
   */
  _disableAutoplay(videoElement: HTMLVideoElement) {
    if (videoElement.hasAttribute('autoplay') && videoElement.hasAttribute('muted')) {
      videoElement.removeAttribute('autoplay');
    }
  }

  /**
   * Check whether the iframe contains supported embed videos or not
   * @param iframe The iframe
   * @returns {boolean} True if iframe contains supported embed videos, False otherwise
   */
  _isVideo(iframe: HTMLIFrameElement): boolean {
    const src = iframe.getAttribute('src');
    return src.includes('https://www.youtube.com/embed/') ||
      src.includes('https://player.vimeo.com/video/')
  }

  /**
   * Disable autoplay on Embedded videos
   * @param iframe The iframe of embedded video
   */
  _disableAutoplayOnEmbeddedVideos(iframe: HTMLIFrameElement) {
    // Check the whether the iframe belongs to embedded videos
    if (this._isVideo(iframe)) {
      const src = iframe.getAttribute('src');
      const url = new URL(src);
      // Remove the autoplay params
      url.searchParams.delete('autoplay');
      iframe.setAttribute('src', url.toString());
    }
  }

  /**
   * Check whether the reduced motion is enabled
   * @returns {boolean} True if it's enabled, False otherwise
   */
  _isReducedMotion(): boolean {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

}

/**
 * @param {Element} element
 */
export function init(element) {
  // eslint-disable-next-line no-new
  new MediaPlayer(element);
}
